<template>
  <DepositSubscriptionCard
    :items="items"
    :button1Text="translate('depositSubscriptionCard.proceed to termination')"
    button2Text="Meld krav"
    :translationPolicyDocument="translate('depositSubscriptionCard.policy document')"
    :policyLink="policyLink"
    :shouldShowButtons="shouldShowButtons"
    @buttonClickTermination="handleTermination"
    @buttonClickDemand="handleDemand"
  />
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import i18nCommon from '@modules/i18n/mixins/Common';
import DepositSubscriptionCard from '@/components/deposit/depositSubscription/DepositSubscriptionCard.vue';

export default Vue.extend({
  name: 'DepositSubscriptionCardContainer',
  props: {
    deposit: {
      type: Object,
      required: true,
    },
  },
  mixins: [i18nCommon],
  components: {
    DepositSubscriptionCard,
  },
  computed: {
    status() {
      const { policy } = this.deposit.meta;

      if (!policy || (!policy.number && !policy.pdf)) {
        return 'ordered';
      }
      if (this.deposit.status === 'conflict') {
        return 'active';
      }
      return this.deposit.status;
    },
    items() {
      const { policy } = this.deposit.meta;
      return [
        {
          title: this.translate('depositSubscriptionCard.items.start date'),
          value: moment(this.deposit.meta.startDate).format('DD.MM.YYYY'),
          icon: 'budicon-calendar',
        },
        {
          title: this.translate('depositSubscriptionCard.items.maximum liability of the guarantor'),
          value: `${Math.ceil(this.deposit.amount).toLocaleString().replaceAll(',', '.')} kr`,
          icon: 'budicon-savings',
        },
        {
          title: this.translate('depositSubscriptionCard.items.warranty number'),
          value: policy ? policy.number : '',
          icon: 'budicon-cheque',
          letterSpacing: true,
        },
      ];
    },
    shouldShowPolicy() {
      const { policy } = this.deposit.meta;

      return ['active', 'ended'].includes(this.status) && policy && policy.pdf;
    },
    policyLink() {
      return this.shouldShowPolicy ? this.deposit.meta.policy.pdf : '';
    },
    shouldShowButtons() {
      return ['ordered', 'active', 'ended'].includes(this.status);
    },
  },
  methods: {
    handleTermination() {
      this.$router.push({
        name: 'tenancy_deposit_release_form_subscription',
        params: {
          depId: this.deposit.id,
        },
      });
    },
    handleDemand() {
      if (typeof this.deposit.claimUrl === 'string' && this.deposit.claimUrl.trim().length > 0) {
        window.open(this.deposit.claimUrl, '_blank', 'noopener');
        return;
      } else {
        window.location.href = 'mailto:post@husleie.no';
      }
    },
  },
});
</script>
